import { Button } from '@wot/components';
import { ITrialClass } from '@wot/typings';
import { useEffect, useState } from 'react';
import { MdClose } from 'react-icons/md';
import { sessionsApi } from '../../api/sessions';
import { CANCEL } from '../../assets/images';
import BottomSheet from '../../components/Bottomsheet';
import { useAppSelector } from '../../hooks';
import { LPlan } from '../../interfaces/Plan';

function CancelPlan({
  plan,
  onCancelPlan,
  setShowCancelPlan
}: {
  plan: LPlan;
  onCancelPlan: () => Promise<boolean>;
  setShowCancelPlan: any;
}) {
  const [sessions, setSessions] = useState<ITrialClass[]>([]);
  const { userData } = useAppSelector((state) => state.userSlice);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (userData?._id) {
      sessionsApi.get(userData._id, { planId: plan._id }).then((data) => {
        setSessions(data);
      });
    }
  }, []);

  const cancelPlan = () => {
    setLoading(true);
    onCancelPlan()
      .then(() => setLoading(false))
      .catch(() => setLoading(false));
  };

  return (
    <BottomSheet height={50}>
      <div className="w-full h-full mt-4 p-5 flex flex-col items-center">
        <div className="w-full flex justify-between">
          <h1 className="w-full mx-auto text-base md:text-xl text-center font-semibold">Cancel Plan</h1>
          <MdClose className="right-0 text-2xl cursor-pointer ml-auto" onClick={() => setShowCancelPlan(false)} />
        </div>
        <div className="flex flex-col items-center justify-center h-full">
          <img src={CANCEL} alt="Cancel Plan" className="mb-4" />
          <h1 className="font-medium text-xl pb-2">Are you sure you want to cancel this plan?</h1>
          <p className="text-lg">{`You still have ${plan.totalSessions - sessions.length} classes left`}</p>
          <p className="text-lg">We recommend you to complete these classes before you cancel the plan.</p>
          <div className="w-32 py-6">
            <Button block type="primary" text={'Cancel Plan'} loading={loading} onClick={() => cancelPlan()} />
          </div>
        </div>
      </div>
    </BottomSheet>
  );
}

export default CancelPlan;
